import classNames from "classnames/bind";
import styles from './CreateCompany.module.css';
import { Col, InputTextBox, Loading, Row, SearchSelect, SelectBox, SelectBoxItem, Toast } from "../../../../components";
import { Previous } from "../../../../components/Icons/Icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { company } from "../../../../services/api/comaniesService";
import { useCallback, useEffect, useState } from "react";
import { addressAPI } from "../../../../services/api/addressAPI";
import { isValidateCompanyCode, sorterAddress } from "../../../../utils";

const cx = classNames.bind(styles);

function CreateCompany() {
    const [nameCompany, setNameCompany] = useState();
    const [taxCode, setTaxCode] = useState();
    const [address, setAddress] = useState();
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [listProvince, setListProvince] = useState([]);
    const [listDistrict, setListDistrict] = useState([]);
    const [listCommune, setListCommune] = useState([]);
    const [province, setProvince] = useState({ name: '', code: null });
    const [district, setDistrict] = useState({ name: '', code: null });
    const [commune, setCommune] = useState({ name: '', code: null });
    const [isSubmit, setIsSubmit] = useState(false);
    const param = useParams();
    const navigate = useNavigate();
    const back = useCallback(() => {
        navigate(-1)
    }, [])
    const getListProvince = async () => {
        try {
            const res = await addressAPI.getProvince(province.name);
            const data = sorterAddress(res, 'PROVINCE_NAME');
            setListProvince(data);
        } catch (error) {
            Toast.open('Không thể lấy danh sách địa chỉ tỉnh', 'danger')
        }
    }
    const getListDistrict = async (code, districtDefault) => {
        try {
            const res = await addressAPI.getDistrict(code, district.name);
            const data = sorterAddress(res, 'DISTRICT_NAME');
            setListDistrict(data);
            if (districtDefault && param.id) {
                const district = res?.find((item) => item.DISTRICT_CODE === districtDefault);
                setDistrict({ name: district?.DISTRICT_NAME, code: district?.DISTRICT_CODE })
            }
        } catch (error) {
            Toast.open('Không thể lấy danh sách địa chỉ huyện', 'danger')
        }
    }
    const getListCommune = async (code, communeDefault) => {
        try {
            const res = await addressAPI.getCommune(code, commune.name);
            const data = sorterAddress(res, 'COMMUNE_NAME');
            setListCommune(data);
            if (communeDefault && param.id) {
                const commune = res?.find((item) => item.COMMUNE_CODE === communeDefault);
                setCommune({ name: commune?.COMMUNE_NAME, code: commune?.COMMUNE_CODE })
            }
        } catch (error) {
            Toast.open('Không thể lấy danh sách địa chỉ xã', 'danger')
        }
    }
    useEffect(() => {
        getListProvince()
    }, [province.name])
    useEffect(() => {
        if (province.code) {
            getListDistrict(province.code)
        }
    }, [province, district.name])
    useEffect(() => {
        if (district.code) {
            getListCommune(district.code)
        }
    }, [district, commune.name])
    const onCreate = async (data) => {
        setLoading(true)
        try {
            const res = await company.post(data)
            Toast.open('Tạo công ty thành công', 'success')
            setLoading(false)
            setTimeout(() => {
                back()
            }, 800)
            return res;
        } catch (error) {
            setLoading(false)
            if (error.response.status === 500) {
                Toast.open('Mã công ty đã được sử dụng', 'danger')
            } else {
                Toast.open('Không tạo được công ty', 'danger')
            }

        }
    }
    const onChangeNameCompany = (data) => {
        setNameCompany(data)
    }
    const onChangeTaxCode = (data) => {
        setTaxCode(data?.toUpperCase())
    }
    const onChangeAddress = (data) => {
        setAddress(data)
    }
    const onChangeNote = (data) => {
        setNote(data)
    }
    const onChangeProvince = (data, label) => {
        setProvince({ code: data, name: label });
        setDistrict({ code: null, name: null });
        setCommune({ code: null, name: null });
        setIsSubmit(false);
    }
    const onChangeDistrict = (data, label) => {
        if (province.code) {
            setDistrict({ code: data, name: label });
            setCommune({ code: null, name: null });
            setIsSubmit(false);
        } else {
            Toast.open('Vui lòng chọn tỉnh / thành phố', 'danger');
        }
    }
    const onChangeCommune = (data, label) => {
        if (district.code) {
            setCommune({ code: data, name: label });
            setIsSubmit(false);
        } else {
            Toast.open('Vui lòng chọn quận / huyện', 'danger');
        }
    }
    const handleCreateCompany = () => {
        let validator = nameCompany?.trim()?.length > 0 && address?.trim()?.length > 0 && commune.code && isValidateCompanyCode(taxCode)
        setIsSubmit(true)
        if (validator) {
            let data = {
                address_detail: address,
                commune_code: commune.code,
                name: nameCompany,
                note: note,
                tax_code: taxCode
            }
            onCreate(data)
        } else {
            Toast.open('Vui lòng nhập đủ các thông tin', 'danger')
        }
    }
    const getInfoCompany = async (id) => {
        const data = {
            company_code: id
        }
        setLoading(true)
        try {
            const res = await company.get(data)
            res?.data?.forEach(item => {
                setNameCompany(item.NAME)
                setAddress(item.PROVINCE_NAME)
                setNote(item.PROVINCE_NAME)
                setTaxCode(item.TAX_CODE)
                setProvince({ name: item.PROVINCE_NAME, code: item.PROVINCE_CODE })
                getListDistrict(item.PROVINCE_CODE, item.DISTRICT_CODE)
                getListCommune(item.DISTRICT_CODE, item.COMMUNE_CODE)
            });
            setLoading(false)
        } catch (error) {
            Toast.open('Lấy thông tin công ty không thành công', 'danger')
            setLoading(false)
        }
    }
    const handleSaveChange = async () => {
        setLoading(true)
        const data = {
            address_detail: address,
            commune_code: commune.code,
            name: nameCompany,
            note: note,
            tax_code: taxCode
        }
        const params = param.id;
        try {
            const res = await company.put(params, data);
            Toast.open('Thay đổi thông tin thành công', 'success');
            setLoading(false);
            setTimeout(() => {
                back()
            }, 800)
            return res;
        } catch (error) {
            setLoading(false);
            Toast.open('Thay đổi thông tin không thành công', 'danger');
        }
    }
    useEffect(() => {
        if (param.id) {
            getInfoCompany(param.id);
        }
    }, [param.id])
    const formatData = (data, type) => {
        if (data.length > 0) {
            const dataFormat = data.map((item) => {
                switch (type) {
                    case 'province':
                        return {
                            name: item.PROVINCE_NAME,
                            code: item.PROVINCE_CODE,
                        }
                    case 'district':
                        return {
                            name: item.DISTRICT_NAME,
                            code: item.DISTRICT_CODE,
                        }
                    case 'commune':
                        return {
                            name: item.COMMUNE_NAME,
                            code: item.COMMUNE_CODE
                        }
                    default:
                        return null
                }
            })
            return dataFormat
        }
    }
    return (
        <div>
            <div id="__notification"></div>
            <div className={cx("header")}>
                <Link style={{ textDecoration: "none" }} to="/admin/companies">
                    <span className={cx("icon")}>
                        <Previous />
                    </span>
                </Link>
                <h1 className={cx("title")}>{param.id ? nameCompany : 'Thêm mới công ty'}</h1>
            </div>
            <div className={cx("content")}>
                <Row gap={[0, 16]}>
                    <Col span={6}>
                        <InputTextBox
                            style={{ marginBottom: 8 }}
                            type="text"
                            placeholder="Nhập"
                            title="Tên công ty *"
                            onChange={onChangeNameCompany}
                            value={nameCompany}
                            error={nameCompany ? false : true}
                            titleError={"Vui lòng nhập tên công ty"}
                        />
                        <InputTextBox
                            style={{ marginBottom: 8 }}
                            type="text"
                            placeholder="Nhập"
                            title="Mã số  công ty*"
                            onChange={onChangeTaxCode}
                            value={taxCode}
                            error={!isValidateCompanyCode(taxCode)}
                            titleError={
                                !isValidateCompanyCode(taxCode) ?
                                    "Mã công ty chỉ chứa các ký tự viết hoa và số" :
                                    "Mã công ty không hợp lệ"}
                        />
                        <InputTextBox
                            style={{ marginBottom: 8 }}
                            type="text"
                            placeholder="Nhập"
                            title="Địa chỉ *"
                            onChange={onChangeAddress}
                            value={address}
                            error={address ? false : true}
                            titleError="Vui lòng nhập tên địa chỉ"
                        />
                        <InputTextBox
                            style={{ marginBottom: 8 }}
                            type="text"
                            placeholder="Nhập"
                            title="Ghi chú"
                            onChange={onChangeNote}
                            value={note}
                        />
                    </Col>
                    <Col span={6}>
                        <div className={cx('selector')}>
                            <SearchSelect
                                placeholder={'Lựa chọn'}
                                require
                                value={province.name}
                                onChange={onChangeProvince}
                                label={'Tỉnh / Thành phố'}
                                dataMap={formatData(listProvince, 'province')}
                            />
                            {isSubmit && !province.code && (<div className={cx('label-error', 'title-error')}>Vui lòng chọn Tỉnh / Thành phố </div>)}
                        </div>
                        <div className={cx('selector')}>
                            <SearchSelect
                                placeholder={'Lựa chọn'}
                                require
                                value={district.name}
                                onChange={onChangeDistrict}
                                label={'Quận / huyện'}
                                dataMap={formatData(listDistrict, 'district')}
                            />
                            {isSubmit && !district.code && (<div className={cx('label-error', 'title-error')}>Vui lòng chọn Quận / huyện * </div>)}
                        </div>
                        <div className={cx('selector')}>
                            <SearchSelect
                                placeholder={'Lựa chọn'}
                                require
                                value={commune.name}
                                onChange={onChangeCommune}
                                label={'Phường / xã'}
                                dataMap={formatData(listCommune, 'commune')}
                            />
                            {isSubmit && !commune.code && (<div className={cx('label-error', 'title-error')}>Vui lòng chọn Phường / xã</div>)}
                        </div>
                    </Col>
                </Row>
                <Row gap={[12, 12]} >
                    {param.id ?
                        (<button onClick={handleSaveChange} className={cx("btn-add")}>
                            Lưu thay đổi
                        </button>) :
                        (<button onClick={handleCreateCompany} className={cx("btn-add")}>
                            Tạo công ty
                        </button>)}
                    <Link style={{ textDecoration: "none" }} to="/admin/companies">
                        <button className={cx("btn-cancel")}>Hủy bỏ</button>
                    </Link>
                </Row>
            </div>
            {loading && (
                <div className={cx('loading-modal')}>
                    <Loading />
                </div>
            )}
        </div>
    )
}

export default CreateCompany;